export default {"src":"/_next/static/media/promotionResultsPage.c5af223e.svg","height":250,"width":435,"blurWidth":0,"blurHeight":0};